export const env = {
    int: (envVar: string, defaultValue: number = null): number => {
        if (envVar === undefined) return defaultValue;
        return parseInt(envVar);
    },
    float: (envVar: string, defaultValue: number = null): number => {
        if (envVar === undefined) return defaultValue;
        return parseFloat(envVar);
    },
    string: (envVar: string, defaultValue: string = null): string => {
        if (envVar === undefined) return defaultValue;
        return envVar;
    },
    array: <T = any>(envVar: string, defaultValue: T[] = []): T[] => {
        if (envVar === undefined) return defaultValue;
        return JSON.parse(envVar);
    },
    object: <T = any>(envVar: string, defaultValue: T = null): T => {
        if (envVar === undefined) return defaultValue;
        return JSON.parse(envVar);
    },
    bool: (envVar: string, defaultValue: boolean = null): boolean => {
        if (envVar === undefined) return defaultValue;
        if (envVar === "1" || envVar === "0") return !!parseInt(envVar);
        return JSON.parse(envVar);
    },
};
